import { Col, Row, Text } from '@keyslabor/shared/ui';
import { useIsMobile } from '@keyslabor/shared/hooks/useBreakPoint';
import ModalConfirm, { Close, Ok } from '@/components/ModalConfirm';
import useModal from '@keyslabor/shared/hooks/useModal';
import {
  FooterProps,
  ModalConfirmProps,
} from '@/components/ModalConfirm/types';
import { useLogOutMutation } from '@/api/methods/useLogOutMutation.ts';

interface Props {
  onSuccess?(): void;
}

export default function useConfirmLogout(props?: Props) {
  const { modalProps, onToggle, show } = useModal();
  const [logout, isLoading] = useLogOutMutation();

  const isMobile = useIsMobile();

  const handleSubmit = async () => {
    console.log('logged-out');
  };

  const content = (
    <>
      <Row textAlign="center" zIndex={999999}>
        <Text fontSize={isMobile ? '16px' : '20px'} fontWeight="700">
          Are you sure you want to log out?
        </Text>
      </Row>
    </>
  );

  const FooterElement = ({ closeProps, okProps }: FooterProps) => {
    return (
      <Row width="100%">
        <Col flexCenter gap={isMobile ? '10px' : '30px'}>
          <Ok
            {...okProps}
            width={'140px'}
            height={isMobile ? '30px' : '40px'}
            bg="blue"
            key="ok"
            kind="normal"
            fontSize={'14px'}
          >
            Confirm
          </Ok>
          <Close
            {...closeProps}
            width={'140px'}
            height={isMobile ? '30px' : '40px'}
            bg="red"
            kind="normal"
            key="cancel"
            fontSize={'14px'}
          >
            Cancel
          </Close>
        </Col>
      </Row>
    );
  };

  const modalSettingsProps: Partial<ModalConfirmProps> = {
    callback: handleSubmit,
    textSuccessOk: 'OK',
    textOk: 'Confirm',
    textClose: 'Cancel',
    titleSuccess: 'Successfully logged out',
    FooterElement: FooterElement,
    onSuccessOk: () => {
      logout();
    },
    children: content,
  };

  return [
    <ModalConfirm
      zIndex={999999}
      key="log-out"
      centerBodyElements={false}
      noBodyPadding
      noContentPadding
      padding={isMobile ? '20px' : '30px 20px 30px 20px'}
      bodyHeight={isMobile ? '80px' : '90px'}
      {...modalSettingsProps}
      {...modalProps}
    />,
    () => {
      onToggle();
    },
  ] as const;
}
